<div class="modal-header">
  <h3 class="modal-title">Update profile image</h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>
</div>

<div class="modal-body">
  <form id="form" (ngSubmit)="submit()" ngNativeValidate>
    <div class="text-center">
      <img [src]="image ? image.filePath : '/images/settings/settings-account/update-profile-image-modal/profile-default.png'" class="img-responsive img-circle" style="max-width: 200px" alt="Profile picture">
    </div>

    <br/>

    <div>
      <input #fileUpload type="file" (change)="uploadFilesClick($event)" accept="image/*" multiple hidden [disabled]="isUploadImagesLoading" class="d-none">
      <div class="dropbox"
           [class]="{ hover: isDropboxHovering }"
           (click)="fileUpload.click()"
           (dragenter)="fileDragEnter($event)"
           (dragover)="fileDragEnter($event)"
           (dragleave)="fileDragLeave()"
           (drop)="fileDrop($event)">
        <div class="text-center">
          <br/>
          <h5 class="m-0">
            <span>Drag images or click to upload (2MB max)</span>
            <span *ngIf="isUploadImagesLoading" class="spinner-border spinner-border-sm ms-2"></span>
          </h5>
          <br/>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="submitted">Cancel</button>
  <button type="submit" class="btn btn-primary" form="form" [disabled]="submitted">
    <span>Submit</span>
    <span *ngIf="submitted" class="spinner-border spinner-border-sm ms-2"></span>
  </button>
</div>
